<template>
  <span class="mc-logo" :class="{ 'con-imagen': mostrarImagen, chico }" :title="nombre ? String(nombre).trim() : null">
    <img v-if="mostrarImagen" :src="url" alt="" loading="lazy" @error="fallo = true" />
    <span v-else class="mc-iniciales" aria-hidden="true">{{ iniciales }}</span>
  </span>
</template>

<script>
/*
 * MarcaLogo — logo de la marca en una pastilla de 64×32 (cabe un emblema o
 * un logo alargado). Sin logo conocido, o si la imagen no carga, muestra las
 * iniciales. Decorativo: el nombre de la marca va siempre en texto al lado.
 * `chico` (44×22) para listas donde la marca es dato secundario (Modelos).
 */
import { logoDeMarca } from '@/utils/logosMarcas'

export default {
  name: 'MarcaLogo',
  props: {
    nombre: { type: String, default: '' },
    chico: { type: Boolean, default: false },
  },
  data() {
    return { fallo: false }
  },
  computed: {
    url() {
      return logoDeMarca(this.nombre)
    },
    mostrarImagen() {
      return Boolean(this.url) && !this.fallo
    },
    iniciales() {
      const palabras = String(this.nombre || '').trim().split(/\s+/).filter(Boolean)
      if (!palabras.length) return '·'
      const texto = palabras.length > 1 ? palabras[0][0] + palabras[1][0] : palabras[0].slice(0, 2)
      return texto.toUpperCase()
    },
  },
  watch: {
    // Otro nombre (p. ej. al escribir en el formulario): se vuelve a intentar
    nombre() {
      this.fallo = false
    },
  },
}
</script>

<style scoped>
.mc-logo {
  display: inline-flex;
  width: 64px;
  height: 32px;
  flex: none;
  align-items: center;
  justify-content: center;
  padding: 3px 6px;
  border: 1px solid #eef2f6;
  border-radius: 8px;
  background: #eaf2fb;
  box-sizing: border-box;
}
.mc-logo.chico {
  width: 44px;
  height: 22px;
  padding: 2px 4px;
  border-radius: 6px;
}
.mc-logo.chico .mc-iniciales {
  font-size: 10px;
}
.mc-logo.con-imagen {
  background: #fff;
}
.mc-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.mc-iniciales {
  color: #0a4f9c;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
